/**
 * subagentDrillStore — which sub-agent's stream the drill-in modal is showing.
 *
 * Its own tiny store (rather than local state) for the same reason as
 * ``searchStore``: the modal has unrelated triggers — a sub-agent row in the
 * "Working" indicator and the ``Task`` tool card in the transcript — and a
 * store lets either open it without prop-drilling through MessageList.
 *
 * Holds the ``Task`` tool_use_id, which is the key both triggers already have
 * and the one the transcript endpoint takes.
 */

import { create } from "zustand";

interface SubagentDrillState {
  /** tool_use_id of the Task call being inspected; null = modal closed. */
  openId: string | null;
  open: (toolUseId: string) => void;
  close: () => void;
}

export const useSubagentDrillStore = create<SubagentDrillState>((set) => ({
  openId: null,
  open: (toolUseId) => set({ openId: toolUseId }),
  close: () => set({ openId: null }),
}));
